var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconCog = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeWidth: "2.167", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", null,
                React.createElement("path", { d: "M18.3,15c0,1.8-1.5,3.3-3.3,3.3s-3.3-1.5-3.3-3.3s1.5-3.3,3.3-3.3S18.3,13.2,18.3,15z" }),
                React.createElement("path", { d: "M23.1,18.3c-0.3,0.7-0.2,1.4,0.4,2l0.1,0.1c0.8,0.8,0.9,2.2,0,3.1c-0.8,0.8-2.2,0.9-3.1,0\n\t\tc0,0,0,0,0,0l-0.1-0.1c-0.7-0.7-1.9-0.7-2.5,0c-0.3,0.3-0.5,0.8-0.5,1.2v0.2c0,1.2-1,2.1-2.2,2.1c-1.2,0-2.1-1-2.1-2.1v-0.1\n\t\tc0-0.7-0.5-1.4-1.2-1.6c-0.7-0.3-1.4-0.2-2,0.4l-0.1,0.1c-0.8,0.8-2.2,0.9-3.1,0c-0.8-0.8-0.9-2.2,0-3.1c0,0,0,0,0,0l0.1-0.1\n\t\tc0.7-0.7,0.7-1.9,0-2.5c-0.3-0.3-0.8-0.5-1.2-0.5H5.3c-1.2,0-2.2-0.9-2.2-2.1C3.1,14,4,13,5.2,13c0,0,0.1,0,0.1,0h0.1\n\t\tc0.7,0,1.4-0.5,1.6-1.2c0.3-0.7,0.2-1.4-0.4-2L6.6,9.8c-0.8-0.8-0.9-2.2,0-3.1s2.2-0.9,3.1,0c0,0,0,0,0,0l0.1,0.1\n\t\tc0.5,0.5,1.3,0.7,2,0.4h0.1c0.7-0.3,1.1-0.9,1.1-1.6V5.3c0-1.2,0.9-2.2,2.1-2.2c1.2,0,2.2,0.9,2.2,2.1c0,0,0,0.1,0,0.1v0.1\n\t\tc0,1,0.8,1.8,1.8,1.8c0.5,0,0.9-0.2,1.2-0.5l0.1-0.1c0.8-0.8,2.2-0.9,3.1,0c0.8,0.8,0.9,2.2,0,3.1c0,0,0,0,0,0l-0.1,0.1\n\t\tc-0.5,0.5-0.7,1.3-0.4,2v0.1c0.3,0.7,0.9,1.1,1.6,1.1h0.2c1.2,0,2.1,1,2.1,2.2c0,1.2-1,2.1-2.1,2.1h-0.1\n\t\tC24,17.2,23.3,17.6,23.1,18.3L23.1,18.3z" })))));
});
export default IconCog;
//# sourceMappingURL=IconCog.js.map